import React from 'react'
import Head from 'next/head'
import { CommonContext } from '@ssr/context'

const APP_ID_DEV = 10000000
const APP_ID_PROD = 10000001

export default function VolcEngine() {
  const { metaData } = React.useContext(CommonContext)
  const isDev = metaData.isDev
  const appId = isDev ? APP_ID_DEV : APP_ID_PROD

  return (
    <Head>
      <script
        dangerouslySetInnerHTML={{
          __html: `
          (function(win, export_obj) {
            win['LogAnalyticsObject'] = export_obj;
            if (!win[export_obj]) {
              var _collect = function() {
                _collect.q.push(arguments);
              }
              _collect.q = _collect.q || [];
              win[export_obj] = _collect;
            }
            win[export_obj].l = +new Date();
          })(window, 'collectEvent');
        `,
        }}></script>
      <script src='https://snssdk.insta360.com/minio.byterangers.onpremise.docor.static/collect-privity-v5.1.12.js' defer></script>
      {/** enable_ab_visual 会检测是否有 下面这个样式，没有的情况会插入把body设置为opcaity 0，导致页面闪烁 */}
      {isDev && <style id='__rangers_ab_style__'></style>}
      <script
        defer
        key='volcengine'
        dangerouslySetInnerHTML={{
          __html: `
          window.collectEvent('init', {
            app_id: ${appId}, // 参考2.1节获取，注意类型是number而非字符串
            channel_domain: 'https://snssdk.insta360.com', // 设置私有化部署数据上送地址，参考2.2节获取
            ab_channel_domain: 'https://snssdk.insta360.com',
            log: false,
            autotrack: false, // 全埋点开关，true开启，false关闭
            enable_debug: ${isDev},
            enable_native: true,
            Native: true,
            enable_ab_test: true,
            enable_multilink: false,
            enable_ab_visual: false,
          });
          window.collectEvent('setNativeAppId', ${appId});
          // 此处可添加设置uuid、设置公共属性等代码
          window.collectEvent('start'); // 通知SDK设置完毕，可以真正开始发送事件了
        `,
        }}
      />
    </Head>
  )
}
